// extracted by mini-css-extract-plugin
export default {"div_alert_text":"AlertText_div_alert_text__yF5Bd"};